import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const OfflineBanner: React.FC = () => {
  const [offline, setOffline] = useState(() => typeof navigator !== 'undefined' ? !navigator.onLine : false);

  useEffect(() => {
    const handleOnline = () => setOffline(false);
    const handleOffline = () => setOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <Snackbar
      open={offline}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ zIndex: 1500, width: '100%' }}
    >
      <Alert severity="warning" variant="filled" sx={{ width: '100%', justifyContent: 'center' }}>
        You are offline. Some features need internet, but the app will keep showing what is already available.
      </Alert>
    </Snackbar>
  );
};

export default OfflineBanner;
